import React from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import styled from 'styled-components/native';

import Image from '@src/components/Image';
import Separator from '@src/components/Separator';
import { H3 } from '@src/components/Typography';
import { activeOpacity, padding } from '@src/configuration/constants';
import { User } from '@src/types';

type Props = {
  item: User;
};

const Container = styled.View`
  width: 95px;
  height: auto;
  border-radius: ${({ theme }) => theme.roundness}px;
  border-color: ${({ theme }) => theme.colors.placeholder};
  border-width: ${StyleSheet.hairlineWidth}px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: ${padding}px;
`;

const size = 55;

const Avatar = styled(Image).attrs({
  resizeMode: 'cover',
})`
  width: ${size}px;
  height: ${size}px;
  border-radius: ${size / 2}px;
  border-width: 3px;
  border-color: ${({ theme }) => theme.colors.primary};
  background-color: ${({ theme }) => theme.colors.placeholder};
`;

const Title = styled(H3).attrs({
  numberOfLines: 1,
  ellipsizeMode: 'tail',
})`
  text-align: center;
`;

const Component: React.FC<Props> = ({
  item: { avatar, name, id, username },
}) => {
  const navigation = useNavigation();
  const handlePress = React.useCallback(
    () => navigation.navigate('Profile', { id }),
    [id, navigation]
  );
  const source = React.useMemo(() => {
    if (avatar?.uri) {
      return { uri: avatar.uri, priority: 'low' };
    } else {
      return require('@src/assets/images/avatar.png');
    }
  }, [avatar]);

  return (
    <TouchableOpacity onPress={handlePress} activeOpacity={activeOpacity}>
      <Container>
        <Avatar source={source} />
        <Separator />
        <Title>{name || username}</Title>
      </Container>
    </TouchableOpacity>
  );
};

Component.displayName = 'HeroCard';

export default React.memo(Component);
